<template>


                <v-card

                        class="mx-auto my-12"
                        max-width="374"
                >   <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        grow
                        color="black"
                >
                    <v-tab

                    >
                        Jag bestämmer
                    </v-tab>
                    <v-tab

                    >
                        Tittaren bestämmer
                    </v-tab>
                </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item

                        >
                            <v-img
                                    v-if="video.opacity>5"
                                    height="250"
                                    :src=image
                                    :style="{'opacity': imageOpacity}"
                            ><v-row align="center" justify="center" style="height:100%;">
                                <v-col></v-col>
                                <v-col style="text-align: center;">
                                    <v-icon x-large color="white" style="opacity:0.8;" class="mx-auto my-auto">mdi-youtube</v-icon>
                                </v-col>
                                <v-col></v-col>

                            </v-row></v-img>
                            <v-img
                                    v-if="video.opacity <=0.5"
                                    height="250"
                                    src="/api/images/cards/no_show.png"

                            ><v-icon>mdi-eye-off</v-icon></v-img>

                            <v-card-title><v-text-field
                                    dense
                                    :value="video.url"
                                    outlined
                                    label="Youtube-länk"
                                    placeholder="https://youtube...."
                                    v-on:input="updateUrl"
                            ></v-text-field></v-card-title>


                            <v-card-text style="margin-top: -40px;" class="pb-0">
                                <v-row style="height: 50px;" justify="center">
                                    <v-col>
                                        <v-text-field
                                                dense
                                                outlined
                                                label="Start-tid"
                                                placeholder="0"
                                                :value="video.start"
                                                type="number"
                                                v-on:input="updateStart"

                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                                dense
                                                outlined
                                                label="Slut-tid"
                                                placeholder="10"
                                                type="number"
                                                :value="video.end"
                                                v-on:input="updateEnd"

                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-slider

                                                prepend-icon="mdi-eye-off"
                                                append-icon="mdi-eye"
                                                v-model="video.opacity"
                                                class="align-center"
                                                :max="video.opacityMax"
                                                :min="video.opacityMin"
                                                hide-details

                                        ></v-slider>
                                    </v-col>
                                </v-row>
                                <v-row style="    margin-top: -20px;">
                                    <v-col>
                                        <v-slider

                                                prepend-icon="volume_down"
                                                append-icon="volume_up"
                                                v-model="video.volume"
                                                class="align-center"
                                                :max="video.volumeMax"
                                                :min="video.volumeMin"
                                                hide-details


                                        ></v-slider>
                                    </v-col>
                                </v-row>


                            </v-card-text>
                            <v-card-actions class="pt-0">
                                <v-btn @click="reset" icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text depressed @click="save">
                                    Spara<v-icon color="grey">save</v-icon>
                                </v-btn>
                            </v-card-actions>


                        </v-tab-item>

                        <v-tab-item>
                            <v-card-text style="text-align: center;">
                                Tittaren väljer ett youtube-klipp att spela upp
                                <v-card-text style="margin-top: -10px;" class="pb-0">
                                    <v-row style="height: 50px;" justify="center">
                                        <v-col>
                                            <v-text-field
                                                    dense
                                                    outlined
                                                    label="Klippets längd"
                                                    placeholder="0"
                                                    type="number"
                                                    :value="video.end"
                                                    v-on:input="updateEnd"

                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                    v-on:change="updateViewerVideo"
                                                    dense
                                                    :items="viewer_video_settings"
                                                    label="Spela upp"
                                                    outlined
                                                    :value="viewer_video_settings_value"
                                            ></v-select>
                                        </v-col>



                                    </v-row>




                                </v-card-text>

                            </v-card-text>
                            <v-card-actions class="pt-0">
                                <v-btn @click="reset" icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text depressed @click="saveViewer">
                                    Spara<v-icon color="grey">save</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-tab-item>

                    </v-tabs-items>






                </v-card>




</template>

<script>
    export default {
        name: "VideoSelector",
        props:{show:Boolean,video_data:Object},
        data(){
            return{
                tab:0,
                updateTimer:null,
                audioVideoGroup:null,
                video:{opacity:100,
                        opacityMin:0,
                        opacityMax:100,
                        volume:100,
                        volumeMax:100,
                        volumeMin:0,
                        video_id:null,
                        url:"",
                        start:0,
                        end:10},
                viewer_video_settings: [
                    { text: 'Ljud'},
                    { text: 'Bild' },
                    { text: 'Ljud + Bild' },
                ],

            }
        },

        methods:{
            hide:function(){
                this.$emit("hide")
            },
            save:function(){
                this.$emit("save")
            },
            saveViewer:function(){
                this.$emit("saveviewer",this.custom_length)
            },
            updateUrl:function(url){
                this.video.url=url;
                const youtube_regex = /^.*(youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|&vi?=)([^#&?]*).*/
                const parsed = url.match(youtube_regex);
                if (parsed && parsed[2]) {

                    this.video.video_id=parsed[2]
                } else {
                    console.log("err");
                }
            },
            updateStart:function(start){
                this.video.start=start;
            },
            updateEnd:function(end){
                this.video.end=end;
            },
            reset:function(){
                this.video.opacity=100;
                this.video.opacityMin=0;
                this.video.opacityMax=100;
                this.video.volume=100;
                this.video.volumeMax=100;
                this.video.volumeMin=0;
                this.video.video_id=null;
                this.video.url="";
                this.video.start=0;
                this.video.end=10;
                this.$emit("updateVideo",this.video);
                this.$emit("save");

            },
            updateViewerVideo:function(payload){
                if(payload==="Ljud"){
                    this.video.volume=100;
                    this.video.opacity=0;
                }
                else if(payload==="Bild"){
                    this.video.volume=0;
                    this.video.opacity=100;
                }
                else if(payload==="Ljud + Bild"){
                    this.video.volume=100;
                    this.video.opacity=100;
                }

            },
            updateVideo:function(){
                let self=this;
                clearTimeout(this.updateTimer);
                this.updateTimer=setTimeout(function(){
                    self.$emit("updateVideo",self.video)
                },500)

            }
        },
        computed:{

            viewer_video_settings_value:function(){
              if(this.video_data.opacity>0 && this.video_data.volume >0){
                  return "Ljud + Bild"
              }
              else if(this.video_data.volume >0){
                  return "Ljud"
              }
              else {
                  return "Bild"
              }
            },

            imageOpacity:function(){
                return this.video.opacity/100
            },
            image:function(){
                if(this.video.video_id!==null){
                    return `https://img.youtube.com/vi/${this.video.video_id}/0.jpg`
                }
                else{
                    return '/api/images/cards/no_video.png'
                }
            }

        },
        watch: {
            video_data: {
                immediate:true,
                handler(){
                    this.video.url=this.video_data.url;
                    this.video.video_id=this.video_data.video_id;
                    this.video.volume=this.video_data.volume;
                    this.video.start=this.video_data.start;
                    this.video.end=this.video_data.end;
                    this.video.opacity=this.video_data.opacity;
                    if(this.video_data.video_id==="FFA"){
                        this.tab=1;
                    }

                },
                deep: true
            },
            video: {
                handler(){
                    this.updateVideo();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
